import React, { type ReactNode } from "react";
import styled from "styled-components";

interface IInfoProps {
  title: string;
  children: ReactNode;
}

export const StyledInfoContainer = styled.div`
  padding: ${(props) => props.theme.block};
  background-color: ${(props) => props.theme.colors.brandWhite};
`;

export const StyledInfoMessage = styled.div`
  margin-bottom: ${(props) => props.theme.block};
  font-size: ${(props) => props.theme.text.size.large};
  width: ${(props) => `calc(12 * ${props.theme.block})`};
  & p {
    margin: ${(props) => props.theme.spacing.medium} 0;
  }
`;

export const StyledInfoTitle = styled.div`
  color: ${(props) => props.theme.text.color.dark};
  font-weight: ${(props) => props.theme.text.weight.semiBold};
  font-size: ${(props) => props.theme.text.size.largest};
  margin-bottom: ${(props) => props.theme.spacing.large};
`;

export default function Info({ title, children }: IInfoProps) {
  return (
    <StyledInfoContainer>
      <StyledInfoTitle>{title}</StyledInfoTitle>
      <StyledInfoMessage>{children}</StyledInfoMessage>
    </StyledInfoContainer>
  );
}
